import {
  ChangeDetectionStrategy,
  Component,
  model,
  output,
} from '@angular/core';

export interface TreeTag {
  label: string;
  value: string;
  active?: boolean;
}

@Component({
  selector: 'lib-tree-tags',
  templateUrl: './tree-tags.component.html',
  styleUrl: './tree-tags.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TreeTagsComponent {
  tags = model<TreeTag[]>([]);
  tagsChanged = output<string>();

  selectTag(value: string) {
    this.tags.update(tags =>
      tags.map(tag => ({
        ...tag,
        active: tag.value === value,
      }))
    );
    this.tagsChanged.emit(value);
  }
}
